/* PAWPATOKI — interacciones (vanilla, sin librerías) */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals() {
    var els = document.querySelectorAll('.pp-reveal');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pp-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('pp-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var fotos = document.querySelectorAll('[data-pp-parallax]');
    if (!fotos.length || reducido) return;
    var pendiente = false;
    function pintar() {
      fotos.forEach(function (el) {
        if (window.innerWidth < 990) { el.style.transform = ''; return; }
        var intensidad = parseFloat(el.getAttribute('data-pp-parallax')) || 0;
        var r = el.getBoundingClientRect();
        var centro = r.top + r.height / 2 - window.innerHeight / 2;
        el.style.transform = 'translate3d(0,' + (centro * -intensidad / 100).toFixed(1) + 'px,0)';
      });
      pendiente = false;
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); }
    }, { passive: true });
    pintar();
  }

  function initGaleria() {
    document.querySelectorAll('[data-pp-galeria]').forEach(function (gal) {
      var principal = gal.querySelector('[data-pp-principal]');
      if (!principal) return;
      gal.querySelectorAll('[data-pp-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          gal.querySelectorAll('[data-pp-mini]').forEach(function (b) { b.classList.remove('is-activa'); });
          btn.classList.add('is-activa');
          principal.style.opacity = 0;
          setTimeout(function () {
            principal.src = btn.getAttribute('data-src');
            principal.srcset = '';
            principal.alt = btn.getAttribute('data-alt') || '';
            principal.style.opacity = 1;
          }, 150);
        });
      });
    });
  }

  function formatearDinero(centimos, formato) {
    var valor = (centimos / 100).toFixed(2);
    var conComa = valor.replace('.', ',');
    var sinDec = Math.round(centimos / 100).toString();
    return (formato || '{{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, sinDec)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, sinDec)
      .replace(/\{\{\s*amount\s*\}\}/, valor);
  }

  function initProducto() {
    document.querySelectorAll('[data-pp-producto]').forEach(function (raiz) {
      var datos = raiz.querySelector('[data-pp-variantes]');
      var formato = raiz.getAttribute('data-pp-moneda');
      var inputId = raiz.querySelector('input[name="id"]');
      var selects = raiz.querySelectorAll('[data-pp-opcion]');
      var precio = raiz.querySelector('[data-pp-precio]');
      var tachado = raiz.querySelector('[data-pp-tachado]');
      var ahorro = raiz.querySelector('[data-pp-ahorro]');
      var botones = raiz.querySelectorAll('[data-pp-anadir]');
      var textoAgotado = raiz.getAttribute('data-pp-agotado');

      // Cantidad
      var cantidad = raiz.querySelector('[data-pp-cantidad]');
      if (cantidad) {
        raiz.querySelectorAll('[data-pp-cant]').forEach(function (b) {
          b.addEventListener('click', function () {
            var v = parseInt(cantidad.value, 10) || 1;
            v += parseInt(b.getAttribute('data-pp-cant'), 10);
            cantidad.value = Math.max(1, v);
          });
        });
      }

      if (!datos || !selects.length) return;
      var variantes = JSON.parse(datos.textContent);
      function valorDe(grupo) {
        if (grupo.tagName === 'SELECT') return grupo.value;
        var marcado = grupo.querySelector('input:checked');
        return marcado ? marcado.value : null;
      }
      selects.forEach(function (s) {
        s.addEventListener('change', function () {
          var etiqueta = s.querySelector('[data-pp-elegida]');
          if (etiqueta) etiqueta.textContent = valorDe(s);
          var elegidas = Array.prototype.map.call(selects, valorDe);
          var v = variantes.find(function (vr) {
            return vr.options.every(function (o, i) { return o === elegidas[i]; });
          });
          botones.forEach(function (b) {
            if (!b.getAttribute('data-texto')) b.setAttribute('data-texto', b.textContent.trim());
          });
          if (!v) {
            botones.forEach(function (b) { b.disabled = true; b.textContent = textoAgotado; });
            return;
          }
          inputId.value = v.id;
          var txtPrecio = v.precio_txt || formatearDinero(v.price, formato);
          if (precio) precio.textContent = txtPrecio;
          var precioBarra = raiz.querySelector('[data-pp-precio-barra]');
          if (precioBarra) precioBarra.textContent = txtPrecio;
          var tallaBarra = raiz.querySelector('[data-pp-talla-barra]');
          if (tallaBarra) tallaBarra.textContent = v.options[0];
          if (tachado) {
            if (v.compare_at_price && v.compare_at_price > v.price) {
              tachado.textContent = v.tachado_txt || formatearDinero(v.compare_at_price, formato);
              tachado.hidden = false;
              if (ahorro) { ahorro.hidden = false; ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
            } else {
              tachado.hidden = true;
              if (ahorro) ahorro.hidden = true;
            }
          }
          botones.forEach(function (b) {
            b.disabled = !v.available;
            b.textContent = v.available ? b.getAttribute('data-texto') : textoAgotado;
          });
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    });
  }

  function initDeslizable() {
    document.querySelectorAll('[data-pp-deslizable]').forEach(function (cont) {
      var pista = cont.querySelector('.pp-prod__pista');
      var puntos = cont.querySelectorAll('.pp-prod__puntos span');
      var num = cont.querySelector('[data-pp-num]');
      if (!pista || !puntos.length) return;
      var pendiente = false;
      pista.addEventListener('scroll', function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () {
          // Las fotos no ocupan todo el ancho (asoma la siguiente): medimos una foto + el hueco
          var slide = pista.querySelector('.pp-prod__slide');
          var paso = slide ? slide.offsetWidth + (parseFloat(getComputedStyle(pista).columnGap) || 0) : pista.clientWidth;
          var i = Math.min(puntos.length - 1, Math.round(pista.scrollLeft / paso));
          if (pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 4) i = puntos.length - 1;
          puntos.forEach(function (p, j) { p.classList.toggle('is-activo', j === i); });
          if (num) num.textContent = i + 1;
          actual = i;
          pendiente = false;
        });
      }, { passive: true });

      // Ir a una foto concreta (puntos y pase automático)
      var actual = 0;
      function irA(i) {
        var slides = pista.querySelectorAll('.pp-prod__slide');
        if (!slides[i]) return;
        pista.scrollTo({ left: slides[i].offsetLeft - pista.offsetLeft, behavior: reducido ? 'auto' : 'smooth' });
      }
      puntos.forEach(function (p, j) {
        p.addEventListener('click', function () { pausar(); irA(j); });
      });

      // Pase automático cada 4 s; se para un rato si el visitante toca la galería y no corre si no se ve
      if (reducido || puntos.length < 2) return;
      var reanudarEn = 0;
      var visible = true;
      function pausar() { reanudarEn = Date.now() + 8000; }
      ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
        pista.addEventListener(ev, pausar, { passive: true });
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(pista);
      }
      setInterval(function () {
        if (!visible || document.hidden || Date.now() < reanudarEn || pista.offsetParent === null) return;
        irA((actual + 1) % puntos.length);
      }, 4000);
    });
  }

  // Ordenador: la foto grande también cambia sola cada 4 s (se para al pasar el ratón)
  function initGaleriaAuto() {
    if (reducido) return;
    document.querySelectorAll('[data-pp-galeria]').forEach(function (gal) {
      var principal = gal.querySelector('.pp-prod__principal');
      var minis = gal.querySelectorAll('[data-pp-mini]');
      if (!principal || minis.length < 2) return;
      var encima = false;
      var reanudarEn = 0;
      gal.addEventListener('mouseenter', function () { encima = true; });
      gal.addEventListener('mouseleave', function () { encima = false; });
      minis.forEach(function (m) { m.addEventListener('click', function (ev) { if (ev.isTrusted) reanudarEn = Date.now() + 8000; }); });
      setInterval(function () {
        if (encima || document.hidden || Date.now() < reanudarEn || principal.offsetParent === null) return;
        var activa = 0;
        minis.forEach(function (m, j) { if (m.classList.contains('is-activa')) activa = j; });
        minis[(activa + 1) % minis.length].click();
      }, 4000);
    });
  }

  function initBarra() {
    document.querySelectorAll('[data-pp-barra]').forEach(function (barra) {
      var raiz = barra.closest('[data-pp-producto]');
      var principal = raiz && raiz.querySelector('.pp-prod__fila');
      if (!principal || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entradas) {
        var e = entradas[0];
        // Mostrar solo cuando el botón principal ya quedó ARRIBA (el usuario bajó)
        var siempre = barra.hasAttribute('data-pp-siempre');
        var mostrar = !e.isIntersecting && (siempre || e.boundingClientRect.top < 0);
        barra.classList.toggle('is-visible', mostrar);
        barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
        document.body.classList.toggle('pp-con-barra', mostrar);
      });
      io.observe(principal);
    });
  }

  // Añadir al carrito sin salir de la página y abrir el carrito lateral (si el tema lo tiene)
  function initCarritoAjax() {
    if (!document.querySelector('cart-drawer') || !window.customElements) return;
    // El carrito lateral del tema se define después que este archivo: esperamos a que esté listo
    customElements.whenDefined('cart-drawer').then(prepararCarritoAjax);
  }

  function prepararCarritoAjax() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    document.querySelectorAll('form.pp-prod__form').forEach(function (form) {
      if (form.dataset.ppAjax) return;
      form.dataset.ppAjax = '1';
      form.addEventListener('submit', function (ev) {
        // Si otra app ya gestionó el envío, no hacemos nada. La app de packs (Rapi) añade sus datos
        // al propio formulario, así que enviamos exactamente los mismos datos sin salir de la página.
        if (ev.defaultPrevented) return;
        var boton = ev.submitter;
        if (boton && boton.name !== 'add') return;
        ev.preventDefault();
        var botones = document.querySelectorAll('[data-pp-anadir]');
        botones.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.classList.add('pp-cargando'); });
        var datos = new FormData(form);
        var secciones = drawer.getSectionsToRender().map(function (s) { return s.id; });
        datos.append('sections', secciones);
        datos.append('sections_url', window.location.pathname);
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: datos
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { form.submit(); return; }
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          })
          .catch(function () { form.submit(); })
          .finally(function () {
            botones.forEach(function (b) { b.removeAttribute('aria-busy'); b.classList.remove('pp-cargando'); });
          });
      });
    });
  }

  // Dato de aduana (MX/PE/CL): se guarda en el carrito al escribirlo, para que no se pierda
  // cuando el carrito lateral se vuelve a pintar, y avisa en español si falta o está mal.
  function initAduana() {
    if (document.documentElement.dataset.ppAduana) return;
    document.documentElement.dataset.ppAduana = '1';
    function esCampo(el) { return el && el.matches && el.matches('[data-pp-aduana]'); }
    document.addEventListener('input', function (ev) {
      if (!esCampo(ev.target)) return;
      ev.target.setCustomValidity('');
      ev.target.closest('.pp-aduana').classList.remove('is-error');
    });
    document.addEventListener('invalid', function (ev) {
      if (!esCampo(ev.target)) return;
      var c = ev.target;
      c.setCustomValidity(c.value.trim() ? c.getAttribute('data-pp-aduana-error') : 'This field is required to ship your order.');
      c.closest('.pp-aduana').classList.add('is-error');
    }, true);
    document.addEventListener('change', function (ev) {
      if (!esCampo(ev.target)) return;
      var c = ev.target;
      c.value = c.value.trim().toUpperCase();
      var attrs = {};
      attrs[c.getAttribute('data-pp-aduana')] = c.value;
      fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    });
  }

  // Barra de urgencia: fecha real de entrega sumando días hábiles (sin sábados ni domingos)
  function initUrgencia() {
    function sumarHabiles(fecha, dias) {
      var d = new Date(fecha);
      while (dias > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) dias--;
      }
      return d;
    }
    function corta(d) {
      return d.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' }).replace('.', '');
    }
    document.querySelectorAll('[data-pp-urgencia]').forEach(function (barra) {
      var hoy = new Date();
      var desde = sumarHabiles(hoy, parseInt(barra.getAttribute('data-min'), 10) || 10);
      var hasta = sumarHabiles(hoy, parseInt(barra.getAttribute('data-max'), 10) || 20);
      var texto = (barra.getAttribute('data-texto') || '').replace('[desde]', corta(desde)).replace('[hasta]', corta(hasta));
      barra.querySelector('[data-pp-urgencia-texto]').textContent = texto;
      barra.hidden = false;
    });
  }

  function iniciar() {
    initUrgencia();
    initAduana();
    initCarritoAjax();
    initReveals();
    initParallax();
    initGaleria();
    initProducto();
    initDeslizable();
    initGaleriaAuto();
    initBarra();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', iniciar);
})();
